var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2712 2.57227H19.8426C20.2973 2.57227 20.7333 2.75288 21.0548 3.07437C21.3763 3.39586 21.5569 3.83189 21.5569 4.28655V21.4294C21.5569 21.8841 21.3763 22.3201 21.0548 22.6416C20.7333 22.9631 20.2973 23.1437 19.8426 23.1437H6.12835C5.67369 23.1437 5.23766 22.9631 4.91617 22.6416C4.59467 22.3201 4.41406 21.8841 4.41406 21.4294V4.28655C4.41406 3.83189 4.59467 3.39586 4.91617 3.07437C5.23766 2.75288 5.67369 2.57227 6.12835 2.57227H8.69978",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5564 0.857422H10.4135C9.95885 0.857422 9.52281 1.03803 9.20132 1.35952C8.87983 1.68102 8.69922 2.11705 8.69922 2.57171V3.42885C8.69922 3.88351 8.87983 4.31954 9.20132 4.64103C9.52281 4.96252 9.95885 5.14314 10.4135 5.14314H15.5564C16.011 5.14314 16.4471 4.96252 16.7685 4.64103C17.09 4.31954 17.2706 3.88351 17.2706 3.42885V2.57171C17.2706 2.11705 17.09 1.68102 16.7685 1.35952C16.4471 1.03803 16.011 0.857422 15.5564 0.857422Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2701 9L11.4129 17.5714L7.98438 15",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamStatusIcon);
export default __webpack_public_path__ + "static/media/exam-status-icon.762cab6004034783ff2bc84ba914dc2c.svg";
export { ForwardRef as ReactComponent };